module.exports = __webpack_public_path__ + "static/img/asideBanner.b7e86430.png";